import { h, Fragment } from 'preact'
import { useContext } from 'preact/compat'
import { Query, Loading } from '../context'
import { JobListing } from './JobListing.jsx'
import { Pagination } from './Pagination.jsx'
import { createUrl } from './../utility/model.js'

import classnames from 'classnames'

export function Results({ results, pagination, onUpdate }) {

	const loading = useContext(Loading)
	const classes = classnames('search-layout__results', loading && 'loading')
	const query = useContext(Query)

	const numberToUrl = number => createUrl(window.location, {
		...query.getAll(), 
		page : number
	})

	const onPageClick = (event, page) => {
		event.preventDefault()
		if (page.current === true || !page.number || page.disabled) return
		query.set('page', page.number)
		query.set('lastEdited', 'page')

		const height = document.documentElement.scrollHeight
		document.body.style.height = `${height}px`
		scrollTo({ top: 0 })
		setTimeout(() => document.body.style.height = '', 1000)
		onUpdate()
	}

	return <div class={classes}>
		{results.map(job => {
			return <JobListing job={job} />
		})}

        {!results.length && !query.get('initial') && <>
        	<div class="margin-bottom first-last">
	        	<h3 class="heading-5">No roles found for your search</h3>
	            <p>Try another search term or alternatively clear any currently selected filters.</p>
	        </div>
        </>}

		<Pagination {...pagination} onUpdate={onUpdate} numberToUrl={numberToUrl} onClick={onPageClick} />
	</div>
}